import { UserButton, useUser } from '@clerk/clerk-react';
import { Link } from '@tanstack/react-router';

export const UserWidget = () => {
  const user = useUser();
  // const navigate = useNavigate();
  // const handleInviteUser = () => {
  //   navigate({ to: '/settings' });
  // };
  return (
    <div className="bq-user-widget">
      <div className="bq-user-box">
        <div className="bq-user-name">
          <span className="welcome">Welcome</span> {user.user?.fullName}
        </div>
        <span className="bq-widget-date">
          {new Date().toISOString().substring(0, 10)}
        </span>
      </div>
      <Link
        to="/user"
        style={{ marginTop: '0px' }}
        activeProps={{
          className: 'font-bold active',
        }}
        activeOptions={{ exact: true }}
      >
        <UserButton>
          {/* <UserButton.MenuItems>
            <UserButton.Action
              label="Invite your team"
              labelIcon={<i className="pi pi-users"></i>}
              onClick={handleInviteUser}
            />
          </UserButton.MenuItems> */}
        </UserButton>
      </Link>
    </div>
  );
};
